export default __webpack_public_path__ + "static/media/supper.d7f5c35d.png";